import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../lib/api-client";
import { queryKeys } from "../../lib/query-keys";

export default function useCart() {
  const {
    data: cart,
    isLoading: isCartLoading,
    isError: isCartError,
    error: cartError,
    isSuccess: isCartSuccess,
  } = useQuery({
    queryKey: queryKeys.cart.userCart(),

    queryFn: () => ApiClient.getUserCart(),
  });

  return { cart, isCartLoading, isCartError, cartError, isCartSuccess };
}
